import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import type { TextingQueueDetailTab } from "./TextingQueueDetailPage";

export const TextingQueueDetailPageTabs = (props: {
  itemTotal: number;
  setCurrentTab: (tab: TextingQueueDetailTab) => void;
}) => {
  const tabs: TextingQueueDetailTab[] = ["Info", "Recipients"];

  return (
    <TabList
      onChange={(event, value) => props.setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => (
        <Tab
          key={tab}
          value={tab}
          label={
            <Stack direction="row" spacing="sm" alignItems="center">
              <Box>{tab}</Box>
              {tab === "Recipients" && <Chip label={props.itemTotal} size="small" />}
            </Stack>
          }
        />
      ))}
    </TabList>
  );
};
